import { render, staticRenderFns } from "./GameProjects.vue?vue&type=template&id=6d0bd5c0&scoped=true&"
import script from "./GameProjects.vue?vue&type=script&lang=ts&"
export * from "./GameProjects.vue?vue&type=script&lang=ts&"
import style0 from "./GameProjects.vue?vue&type=style&index=0&id=6d0bd5c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0bd5c0",
  null
  
)

export default component.exports